module.exports = {"341504100":"叶集镇镇区","341504101":"叶集镇平岗","341504102":"三元镇","341504200":"孙岗乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341504.json
// module id = 1044
// module chunks = 0